import { DOCUMENT } from '@angular/common';
import { Component, OnInit,Inject } from '@angular/core';
import { HomepageService } from '../../../services/homepage.service';
import { SearchService } from '../../../services/search.service';
import { StarRatingModule } from 'angular-star-rating';
import { RouterExtService } from '../../../services/previous-route.service';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from '../../../services/auth.service';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { DatepickerOptions } from 'ng2-datepicker';
@Component({
  selector: 'app-popular-list',
  templateUrl: './popular-list.component.html',
  styleUrls: ['./popular-list.component.css']
})
export class PopularListComponent implements OnInit {
  private readonly notifier: NotifierService;
  constructor( private authService: AuthService, private searchService: SearchService,private homepageService: HomepageService,@Inject(DOCUMENT) private document: Document,private routerService: RouterExtService, private cookieService: CookieService, private router: Router,private activatedRoute: ActivatedRoute, notifierService: NotifierService ) {
    this.notifier = notifierService;
  }
  exploreoptions:boolean = false;
  seletedExploreOptions: string = '';
  printStyle: string = '';
  librarySetting:any = [];
  resoursesCount : number = 0;
	bulletinlist: any = [];
	responseAPIstatus: boolean = true;
  serachDataVisible: boolean = false;
  viewprintstatus: boolean = false;
  serachDataVisible1: boolean = false;
 lazyRequeat: boolean;  
  listSize: number = 5;
  pagesCount: any [];
  sortWith: string = 'date';
  descendingWith: boolean = true;
  currentOffset: number =0;
  listView: string = 'true';
  viewRefresh = true;
  narrowFilters:  any[] = [];
  maxRecords:  number = 100;
  totalRecords:  number;
  infiniteScroll:  boolean = true;
  facetsInformation:  any[];
  selectedResourcesIds: any = [];
  updateMobileToggleInfo: boolean = false;
  exportOptions:any = [];
  exportEmailOptions:any = []; 
  isPatronLogin:boolean = false;
  facets:  any = [];
  exportDownloadOptions:  any = [];
  patronEmail: string = '';
  sendingMail:boolean = false;

  showAddFormStatus :boolean = false;
  showHoldDate :boolean = false;
  date:any = new Date(Date.now());
  lastDayDate:any = '';
  exploreId = null;
 	ngOnInit() {
    var settingData=this.homepageService.getUpdatedConfig();
    this.listSize = settingData.data.settings.newInLibrary.listSize;
     var dd = new Date(Date.now());
    this.lastDayDate = dd.setDate(dd.getDate()-1); 
    if(this.cookieService.check('userDetail'))
    this.patronEmail = JSON.parse(this.cookieService.get('userDetail')).email; 

  this.activatedRoute.queryParams.subscribe(params => {
    if(typeof(params.facets) != 'undefined'  && params.facets != ''){
      var tempFactes = params.facets.split(",");
      for(var i=0; i < tempFactes.length; i++){
        var index = this.facets.indexOf(parseInt(tempFactes[i]));
        if(index < 0){
          this.facets.push(parseInt(tempFactes[i]));
        }
      }      
    }
    if(typeof(params.order) != 'undefined'  && params.order != ''){
      this.sortWith = params.order;
      
    }
    this.exploreId = params['exp-btn-id'];
   });  
 		this.document.body.classList.add('inner-page');
     this.document.body.classList.add('list');
    if(this.sortWith == 'date'){
      this.descendingWith = true;
    } else {
      this.descendingWith = false;
    }
 		this.getpopularlist(this.sortWith, this.descendingWith);
    this.routerService.setTextUrl('Popular Titles');
    if( localStorage.getItem('selectedResourcesIds') != null ){
      this.selectedResourcesIds = JSON.parse(localStorage.getItem('selectedResourcesIds'));          
     
    }
    //if(this.cookieService.check( 'info') ){
    if (localStorage.getItem('info')){
      this.isPatronLogin = true;
    }
 	}
 	
  openDailog(type){
    $('.exploreCon').removeClass('openExploreOption');
    $('#emailType').val(type.toUpperCase());
  }
  exportListEmail(event,cacheKey){
    this.sendingMail = true;
    //console.log(cacheKey, $('#emailType').val());
    this.homepageService.getEmail(cacheKey, this.facets, $('#emailType').val()).subscribe((data:any) => {
      this.sendingMail = false;
      $('#closeEmailModal').trigger('click');
      if(data.status)
      this.notifier.notify('success', data.message);
      else
      this.notifier.notify('error', data.message);
    },(error) => {
      this.sendingMail = false;
      $('#closeEmailModal').trigger('click');
      this.notifier.notify('error', error.error.title);
      error.error.errors.id.forEach((res)=>{
        this.notifier.notify('error', res);
      });
    });
  }

  getpopularlist(sortBy,descending){
         var data =   this.homepageService.getUpdatedConfig();  
         this.librarySetting = data;
         if(this.librarySetting.data.settings.resultList.export.formats.list){
            var temp:object = [];
             temp['key'] = 'list';
             temp['value'] = 'List';
            this.exportOptions.push(temp);
            this.exportEmailOptions.push(temp);
          }
          if(this.librarySetting.data.settings.resultList.export.formats.listWithImage){
            var temp:object = [];
             temp['key'] = 'listwithimage';
             temp['value'] = 'List with Images';
            this.exportOptions.push(temp);
          }
          if(this.librarySetting.data.settings.resultList.export.formats.listWithImageAndSummary){
            var temp:object = [];
             temp['key'] = 'listWithImageAndSummary';
             temp['value'] = 'List with Images and Summary';
             //this.printStyle = 'summary';
            this.exportOptions.push(temp);
          }
          if(this.librarySetting.data.settings.resultList.export.formats.apa){
            var temp:object = [];
            temp['key'] = 'apa';
            temp['value'] = 'Bibliography - APA';
            this.exportOptions.push(temp);
            this.exportEmailOptions.push(temp);
          }
          if(this.librarySetting.data.settings.resultList.export.formats.mla){
            var temp:object = [];
            temp['key'] = 'mla';
            temp['value'] = 'Bibliography -  MLA';
            this.exportOptions.push(temp);
            this.exportEmailOptions.push(temp);
          }
          if(this.librarySetting.data.settings.resultList.export.formats.chicago){
            var temp:object = [];
            temp['key'] = 'cmos';
            temp['value'] = 'Bibliography - Chicago Style';
            this.exportOptions.push(temp);
            this.exportEmailOptions.push(temp);
          }
          if(this.librarySetting.data.settings.resultList.export.formats.csv){
            var temp:object = [];
            temp['key'] = 'csv';
            temp['value'] = 'CSV';
            this.exportDownloadOptions.push(temp);
          }
          if(this.librarySetting.data.settings.resultList.export.formats.marc){
            var temp:object = [];
            temp['key'] = 'marc';
            temp['value'] = 'Marc';
            this.exportDownloadOptions.push(temp);
          }
          this.maxRecords = data.data.settings.resultList.maxItems;
          this.infiniteScroll = data.data.settings.resultList.infiniteScroll;           
          this.infiniteScroll = data.data.settings.resultList.infiniteScroll;           

          if(data.data.settings.search.filter.availability.enabled === true){
            this.narrowFilters.push('ava');
          } 
          if(data.data.settings.search.filter.category.enabled === true){
            this.narrowFilters.push('cat');
          } 
          if(data.data.settings.search.filter.lexile.enabled === true){
            this.narrowFilters.push('lxl');
          }
          if(data.data.settings.search.filter.lexileGrade.enabled === true){
            this.narrowFilters.push('lxg');
          }
          if(data.data.settings.search.filter.lexileCode.enabled === true){
            this.narrowFilters.push('lxc');
          }
          if(data.data.settings.search.filter.fountas.enabled === true){
            this.narrowFilters.push('fpl');
          }
          if(data.data.settings.search.filter.rc.enabled === true){
            this.narrowFilters.push('rcl');
          }
          if(data.data.settings.search.filter.ar.enabled === true){
            this.narrowFilters.push('arl');
          }
          if(data.data.settings.search.filter.arInterest.enabled === true){
            this.narrowFilters.push('ari');
          }
          if(data.data.settings.search.filter.year.enabled === true){
            this.narrowFilters.push('pub');
          }
          if(data.data.settings.search.filter.series.enabled === true){
            this.narrowFilters.push('ser');
          }
          if(data.data.settings.search.filter.subject.enabled === true){
            this.narrowFilters.push('sub');
          }
          if(data.status === true && data.data.settings.resultList.pageSize){
            this.listSize = data.data.settings.resultList.pageSize;
            if (sortBy == 'date') {
              descending = true;
            } else {
              descending = false;
            }
         return this.homepageService.getPopularPage(sortBy,descending,this.listSize,this.facets.join(), this.exploreId).subscribe((data) => {
              this.totalRecords = data.data.totalCount; 
              this.bulletinlist = data;
              this.updateFacets(this.bulletinlist.data.facets);
              var pages = (data.data.totalCount / this.listSize);
              this.createRange(pages);
              this.responseAPIstatus = false;
              this.viewRefresh = false;
              if(this.librarySetting.data.settings.resultList.defaultView == 'compact list'){
                this.listView = 'compact';
              }else if(this.librarySetting.data.settings.resultList.defaultView == 'list'){
                this.listView = 'true';
              }else if(this.librarySetting.data.settings.resultList.defaultView == 'grid'){
                this.listView = 'false';
              }
              if(!this.cookieService.check('Popular_title_List_View')){
              this.cookieService.set( 'Popular_title_List_View', this.listView, 365,'/');      
              } else {     
                this.listView = this.cookieService.get('Popular_title_List_View');
              }  
            })
        }
      }



    lazyLoading(cache, currentOffset, listSize){
      var offset = (currentOffset + listSize);
      if(this.lazyRequeat == true || this.infiniteScroll === false || this.totalRecords < offset){
        return false;
      }
      this.lazyRequeat = true;
      if(this.maxRecords > offset){
        return this.homepageService.getSortPageByCache(this.sortWith,this.descendingWith,cache,this.listSize, offset, this.facets.join()).subscribe((data) => {
          data.data.resources.forEach((evt) => {
            this.bulletinlist.data.resources.push(evt);
          });
          this.lazyRequeat = false;
          this.viewRefresh = false;
          this.currentOffset = offset;
        });
      }
    }

    getListSort(sortBy,descending,cache, offset){
      if(sortBy === null){
        sortBy =  this.sortWith;
      }
      this.sortWith = sortBy;
      if(descending === null){
        descending =  this.descendingWith;
      }
      this.descendingWith = descending;
      this.currentOffset = offset;
      this.viewRefresh = true;
      return this.homepageService.getSortPageByCache(sortBy,descending,cache,this.listSize, offset, this.facets.join()).subscribe((data) => {
        this.bulletinlist = data;
        this.updateFacets(this.bulletinlist.data.facets);
        var pages = (data.data.totalCount / this.listSize);
        this.createRange(pages);
        this.viewRefresh = false;
        this.router.navigate(
            [], 
            {
              relativeTo: this.activatedRoute,
              queryParams:{
                order: this.sortWith,
              },
              queryParamsHandling: "merge"
            }
          )
      });
    }

    serachDataVisibleFn(){
      this.serachDataVisible = true;      
    }

    serachDataVisibleFn1(){
      this.serachDataVisible1 = true;      
    }

    changeView(view){
      this.listView = view;
      this.cookieService.set( 'Popular_title_List_View', this.listView, 365,'/' );
      this.viewRefresh = true;
      setTimeout(() => {
      this.viewRefresh = false;
      }, 500); 
    }

    createRange(number){
      var items: any[] = [];
      for(var i = 0; i < number; i++){
         items.push(i);
      }
      this.pagesCount =  items;
    }

    //Showing icon for image error.
    imageError(event, images){
      if(typeof($('body').find('img[custom="'+event+'"]').attr('index')) != 'undefined' &&  parseInt($('body').find('img[custom="'+event+'"]').attr('index')) > 0 ){
        var index:number = parseInt($('body').find('img[custom="'+event+'"]').attr('index'));
        if(typeof($('body').find('img[custom="'+event+'"]').attr('loaded')) != 'undefined')
        index--;
        this.imageLoad(event, images,index, true);
      } else {
        $('body').find('img[custom="'+event+'"]').after('<span class="Placeholders '+$('body').find('img[custom="'+event+'"]').attr('name')+'"><i class="material-icons md-48">'+$('body').find('img[custom="'+event+'"]').attr('alt')+'</i></span>');
        $('body').find('img[custom="'+event+'"]').remove();          
      }
    }
    
    //loading best image
    imageLoad(event, images,index, fromError = false) {
      if($('body').find('img[custom="'+event+'"]').attr('loaded') == 'yes' && !fromError) {
        return false;
      }
      if($('body').find('#'+event).length <= 0) {
         $('body').append('<img id="'+event+'" src="" style="display:none;">');
      }
      var $this = this;
      var imagesAll = this.searchService.sortedImage(images);
      $('#'+event).attr('src',imagesAll[index]);
      setTimeout(function(){
        var tempWidth = $('#'+event).width();
        //console.log(tempWidth, event, index);
        var temp = document.getElementById(event);
        if(tempWidth <= 1 && index > 0){
          $this.imageLoad(event,images,index-1, true);
          return false;
        }else if(tempWidth <= 1 && index == 0){
          $('body').find('img[custom="'+event+'"]').after('<span class="Placeholders '+$('body').find('img[custom="'+event+'"]').attr('name')+'"><i class="material-icons md-48">'+$('body').find('img[custom="'+event+'"]').attr('alt')+'</i></span>');
          $('body').find('img[custom="'+event+'"]').remove();
        }
      },500);
      if(typeof(imagesAll[index]) != 'undefined') {
        $('body').find('img[custom="'+event+'"]').attr('src',imagesAll[index]);
        $('body').find('img[custom="'+event+'"]').attr('loaded','yes');        
        $('body').find('img[custom="'+event+'"]').attr('index',index);        
      }
    }

    /*

    imageError(event){
      $('body').find('img[custom="'+event+'"]').after('<span class="Placeholders '+$('body').find('img[custom="'+event+'"]').attr('name')+'"><i class="material-icons md-48">'+$('body').find('img[custom="'+event+'"]').attr('alt')+'</i></span>');
      $('body').find('img[custom="'+event+'"]').remove();
    }


    imageLoad(event, images) {
      if($('body').find('img[custom="'+event+'"]').attr('loaded') == 'yes') {
        return false;
      }
      var sizes = ['xl','l','m','s','xs','xxs'];
      if($('body').find('#TempImg').length <= 0) {
        $('body').append('<img id="TempImg" src="" style="display:none;">');
      }
      var imagesAll = [];
      sizes.forEach((evt) => {
        images.forEach((img) => {
          if(img.size == evt){
            imagesAll.push(img.url);
          }
        });      
      });

      setTimeout(function() {
        if(typeof(imagesAll[0]) != 'undefined') {
          $('body').find('img[custom="'+event+'"]').attr('src',imagesAll[0]);
          $('body').find('img[custom="'+event+'"]').attr('loaded','yes');        
        } 
      },10);
    }
  */
    narrowSearch(event, cacheKey,facetId) {
      var index = this.facets.indexOf(facetId);
      if(index > -1){
        this.facets.splice(index, 1);
      } else {
        this.facets.push(facetId);      
      }
      this.viewRefresh = true;
      return this.homepageService.searchNorrowResult(this.sortWith,this.descendingWith,cacheKey,this.listSize, 0,this.facets.join(), this.exploreId).subscribe((data) => {
        this.totalRecords = data.data.totalCount; 
        this.bulletinlist = data;
        this.updateFacets(this.bulletinlist.data.facets);
        var pages = (data.data.totalCount / this.listSize);
        this.createRange(pages);
        this.responseAPIstatus = false;
        this.viewRefresh = false;
        this.router.navigate(
          [], 
          {
            relativeTo: this.activatedRoute,
            queryParams:{
              facets: this.facets.join(),
            },
            queryParamsHandling: "merge"
          }
        )
      });
    }

    removeNorrow(cacheKey,facetId){
      var index = this.facets.indexOf(facetId);
      if(index > -1){
        this.facets.splice(index, 1);
      }
      this.viewRefresh = true;
      return this.homepageService.searchNorrowResult(this.sortWith,this.descendingWith,cacheKey,this.listSize, 0,this.facets.join(), this.exploreId).subscribe((data) => {
        this.totalRecords = data.data.totalCount; 
        this.bulletinlist = data;
        this.updateFacets(this.bulletinlist.data.facets);
        var pages = (data.data.totalCount / this.listSize);
        this.createRange(pages);
        this.responseAPIstatus = false;
        this.viewRefresh = false;
        this.router.navigate(
          [], 
          {
            relativeTo: this.activatedRoute,
            queryParams: {
              facets: this.facets.join(),
            },
            queryParamsHandling: "merge"
          }
        )
      });
    }

    updateFacets(facets){
      this.facetsInformation = [];
      facets.forEach((facets) => {
        var facetsData = [];
        if(this.narrowFilters.indexOf(facets.key) > -1 && facets.values[0] ){
          facets.values.forEach((fv) =>  {
            if(parseInt(fv.count) > 0 ){
              facetsData.push(fv);
            }
          });
        }
        if(facetsData[0]){
          var temp = {};
          temp['key'] =  facets.key;  
          temp['caption'] =  facets.caption;  
          temp['selectedId'] =  facets.selectedId;  
          temp['selectedValue'] =  facets.selectedValue;  
          temp['listOrder'] =  facets.listOrder;  
          temp['values'] =  facetsData;
          this.facetsInformation.push(temp);
        }
      });
    }


    addToMyList(event, Id){
      var self = this;
      $('.addButton'+Id).addClass('fadeOutUp');
      $('#myCollectionLi').addClass('fadeOutUpLI');
      setTimeout(function(){
        $('.addButton'+Id).addClass('hide').removeClass('show').removeClass('fadeOutUp');
        $('.removeButton'+Id).addClass('show').removeClass('hide');        
        this.resoursesCount = $('.addButton'+Id).length;
        var currentList = parseInt($('#myCollectionLi').find('span.count').text());
        self.cookieService.set( 'MyLIstCount' , (currentList + this.resoursesCount) );
        $('#myCollectionLi').find('span.count').text(currentList + this.resoursesCount);
        $('#myCollectionLi').find('a.onViewList').removeClass('hide').addClass('show');
        $('#Publish-My-List').removeClass('hide').addClass('show');
        if($('#myCollectionLi').hasClass('hide')){
          $('#myCollectionLi').removeClass('hide');
          $('#myCollectionLi').addClass('show');
        }
        var i:number; 
        for (i = 1;i <= this.resoursesCount;i++) {
          self.selectedResourcesIds.push(Id);
        }
        localStorage.setItem('selectedResourcesIds', JSON.stringify(self.selectedResourcesIds));    
        //if(self.cookieService.check( 'info')){
        if(localStorage.getItem('info')){
          var auth = localStorage.getItem('token');
          self.homepageService.saveMyList(auth,self.selectedResourcesIds).subscribe(data => { },
          (error) => {
           
                if(self.cookieService.check('tempPersonalCollection')){
                  var cacheKey = self.cookieService.get('tempPersonalCollection');
                } else {
                  var cacheKey = '';              
                }
                var itemIds:any = []; 
                itemIds.push(Id);
                self.homepageService.personalcollection(itemIds, cacheKey).subscribe(data => { 
                  if(data.status){
                    self.cookieService.set( 'tempPersonalCollection', data.data.cacheKey, 365,'/');      
                  }
                });
          });
        } else {
          if(self.cookieService.check('tempPersonalCollection')){
            var cacheKey = self.cookieService.get('tempPersonalCollection');
          } else {
            var cacheKey = '';              
          }
          var itemIds:any = []; 
          itemIds.push(Id);
          self.homepageService.personalcollection(itemIds, cacheKey).subscribe(data => { 
            if(data.status){
              self.cookieService.set( 'tempPersonalCollection', data.data.cacheKey, 365,'/');      
            }
          });
        }        
      }, 1000);   
      setTimeout(function(){
        $('#myCollectionLi').removeClass('fadeOutUpLI');    
      }, 5000);
    }

    removeToMyList(event,Id){
      $(document).find('.addButton'+Id).addClass('show').removeClass('hide');
      $(document).find('.removeButton'+Id).addClass('hide').removeClass('show');
      this.resoursesCount = $('.removeButton'+Id).length;
      var i:number; 
      for (i = 1;i <= this.resoursesCount;i++) {
        var index = this.selectedResourcesIds.indexOf(Id);
        if (index > -1) {
         var index = this.selectedResourcesIds.splice(index, 1);
        }      
      }    
      localStorage.setItem('selectedResourcesIds', JSON.stringify(this.selectedResourcesIds));    
      var currentList = parseInt($('#myCollectionLi').find('span.count').text());
      $('#myCollectionLi').find('span.count').text(currentList - this.resoursesCount);
      var tempCurrentList=currentList - this.resoursesCount;
      this.cookieService.set('MyLIstCount',(tempCurrentList.toString()));
      //if(this.cookieService.check( 'info')){
      if(localStorage.getItem('info')){
        var auth =  localStorage.getItem('token');
        this.homepageService.removeMyList(auth,Id).subscribe(data => { });
      } else {
        if(this.cookieService.check('tempPersonalCollection')){
          var cacheKey = this.cookieService.get('tempPersonalCollection');
          this.homepageService.removePersonalcollection(Id, cacheKey).subscribe(data => {});
        } 
      } 
    }

    updateMobileToggle(event){
      if($(event.target).hasClass('open')){
        this.updateMobileToggleInfo = false;      
      } else {
        this.updateMobileToggleInfo = true;      
      }
    }

    showExportOptions(event, type){
      event.preventDefault();
      if(this.seletedExploreOptions != type){
        $('.exploreCon').removeClass('openExploreOption');
      }        
      if(event.target.nodeName == 'I'){
        var seletor = $(event.target).parent();
      } else {
        var seletor = $(event.target);
      }
      seletor.parent().toggleClass('openExploreOption');
      this.seletedExploreOptions = type;
    }  
  
    exportList(event,cacheKey,type){
      $('.exploreCon').removeClass('openExploreOption');
      if(type == 'listwithimage' ){
        this.listView = 'true';
        this.viewprintstatus = true;
        this.homepageService.getPopularPage(this.sortWith, this.descendingWith,10000,this.facets.join(), this.exploreId).subscribe(( data: any) => {
          this.totalRecords = data.data.totalCount; 
          this.bulletinlist = data;
          this.updateFacets(this.bulletinlist.data.facets);
          var pages = (data.data.totalCount / this.listSize);
          this.createRange(pages);
          var self = this;
          setTimeout(function(){
            var libraryname = '';
            var tnt = self.librarySetting.data.tenantCode.toLowerCase();
            var slctloc = self.cookieService.get('selectedlocation'+tnt);            
            self.librarySetting.data.settings.location.locations.forEach((loc) =>{
              if(parseInt(loc.id) == parseInt(slctloc) ){
                libraryname = loc.name;
              }
            });
            var html = $('div.list-view').html();
            self.printFnWithHtml(html,libraryname);
            self.viewprintstatus = false;
            self.currentOffset = 10000;
          },2000);
        });
       } 
      else if(type == 'listWithImageAndSummary'){
        this.listView ='summary';
        this.viewprintstatus = true;
        this.homepageService.getPopularPage(this.sortWith, this.descendingWith,10000,this.facets.join(), this.exploreId).subscribe(( data: any) => {
          this.totalRecords = data.data.totalCount; 
          this.bulletinlist = data;
          this.updateFacets(this.bulletinlist.data.facets);
          var pages = (data.data.totalCount / this.listSize);
          this.createRange(pages);
          var self = this;
          setTimeout(function(){
            var libraryname = '';
            var tnt = self.librarySetting.data.tenantCode.toLowerCase();
            var slctloc = self.cookieService.get('selectedlocation'+tnt);            
            self.librarySetting.data.settings.location.locations.forEach((loc) =>{
              if(parseInt(loc.id) == parseInt(slctloc) ){
                libraryname = loc.name;
              }
            });
            var html = $('div.list-summary').html();
            self.printFnWithHtml(html,libraryname);
            self.viewprintstatus = false;
            self.currentOffset = 10000;
          },2000);
        });
      }
      else if(type == 'list'){
      this.listView = 'true';
      this.viewprintstatus = true;
      this.homepageService.getPopularPage(this.sortWith, this.descendingWith,10000,this.facets.join(), this.exploreId).subscribe(( data: any) => {           
          var html: string = '';           
          data.data.resources.forEach((list) =>{
             html += '<p class="hangingindent" style="float: left;width: 100%;">';
             html += '<span style="font-size:15px;font-weight: 600; float:left;">'+list.title+'</span><br/><span style=" font-size:15px; float:left; width:100%;">'+list.author+'</span><br/><span style="font-size:15px;float:left; width:100%;">'+list.call+'</span>';
             html += '</p>';
          });
           var libraryname = '';
            var tnt = this.librarySetting.data.tenantCode.toLowerCase();
            var slctloc = this.cookieService.get('selectedlocation'+tnt);            
            this.librarySetting.data.settings.location.locations.forEach((loc) =>{
              if(parseInt(loc.id) == parseInt(slctloc) ){
                libraryname = loc.name;
              }
            });
          this.printFn(html,libraryname);
          this.viewprintstatus = false;
        });
    } else if(type == 'csv'){
      this.homepageService.getCSV(cacheKey, this.facets).subscribe((data:File) => {
        var device = ['iPhone', 'iPad', 'iPod'];
        const csvName = 'Library Resources.csv';
        const blob = new Blob([data], {type: 'text/csv'});
        if(device.indexOf(window.navigator.platform) > -1 ) {
          if (window.navigator.userAgent.match('CriOS')) { //Chrome iOS
            var reader = new FileReader();
            reader.onloadend = function(e) {
              const reader_result = reader.result;
              if (typeof reader_result === 'string') {
                window.open(reader_result);
              }
              else {
                window.open(reader_result.toString());
              }
            }
            reader.readAsDataURL(blob);
          } else { //Safari & Opera iOS
            const a = document.createElement('a');
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = csvName;
            a.click();
            setTimeout(function(){
              window.URL.revokeObjectURL(url);
              a.remove();
            },200);
          }
       // } else if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE
        //  window.navigator.msSaveOrOpenBlob(blob, csvName);
        } else { //Chrome & Firefox
          const a = document.createElement('a');
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = csvName;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove();
        }
      },
      (error) => {
        this.notifier.notify('error', error.error.title);
        error.error.errors.id.forEach((res)=>{
          this.notifier.notify('error', res);
        });
      });
    } else if(type == 'marc'){
      this.homepageService.getMarc(cacheKey, this.facets).subscribe((data:File) => {
        var device = ['iPhone', 'iPad', 'iPod'];
        const csvName = 'Library Resources.mrc';
        const blob = new Blob([data], {type: 'application/marc'});
        if(device.indexOf(window.navigator.platform) > -1 ) {
          if (window.navigator.userAgent.match('CriOS')) { //Chrome iOS
            var reader = new FileReader();
            reader.onloadend = function(e) {
              const reader_result = reader.result;
              if (typeof reader_result === 'string') {
                window.open(reader_result);
              }
              else {
                window.open(reader_result.toString());
              }
            }
            reader.readAsDataURL(blob);
          } else { //Safari & Opera iOS
            const a = document.createElement('a');
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = csvName;
            a.click();
            setTimeout(function(){
              window.URL.revokeObjectURL(url);
              a.remove();
            },200);
          }
       // } else if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE
         // window.navigator.msSaveOrOpenBlob(blob, csvName);
        } else { //Chrome & Firefox
          const a = document.createElement('a');
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = csvName;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove();
        }
      },
      (error) => {
        this.notifier.notify('error', error.error.title);
        error.error.errors.id.forEach((res)=>{
          this.notifier.notify('error', res);
        });
      });
    } else {
        this.homepageService.printFormat(cacheKey, this.facets,type).subscribe( (data:any) => {
          var html: string = ''; 
          data.data.items.forEach((items,key) =>{
            html += '<p class="hangingindent">';
            items.elements.forEach((text) =>{
              var style = "normal";
              if(text.italic){
                var style = "italic";
              }
              html += '<span style="font-style: '+style+'; font-size:15px;">'+text.text+'</span> ';
            });
            html += '</p>';
          });
          this.printFn(html);
        });
      }
    }

    printFnWithHtml(content,libraryName){
      var mywindow = window.open('', '_blank');
      mywindow.document.write('<html><head><title>Print</title><link href="https://fonts.googleapis.com/css?family=Roboto:100,100i,300,300i,400,400i,500,500i,700,700i,900,900i" rel="stylesheet"><style>@font-face {font-family: "Material Icons";font-style: normal;font-weight: 400;src: url(https://fonts.gstatic.com/s/materialicons/v48/flUhRq6tzZclQEJ-Vdg-IuiaDsNc.woff2) format("woff2");}.material-icons {font-family: "Material Icons";font-weight: normal;font-style: normal;font-size: 24px;line-height: 1;letter-spacing: normal;text-transform: none;display: inline-block;white-space: nowrap;word-wrap: normal;direction: ltr;-moz-font-feature-settings: "liga";-moz-osx-font-smoothing: grayscale;} body{font-family:"Roboto", sans-serif !important;} p {color:#8c8c8c;}.hangingindent {padding-left: 36px ;text-indent: -36px; }.book-box {display:flex;border-bottom: 1px dashed rgba(0, 0, 0, 0.1);padding: 7px 0;width: 100%;position: relative;}.book-image {height: 55px;overflow:hidden;border: 1px solid rgba(0, 0, 0, 0.1);float: left;padding: 4px;width: 45px;}.book-box .book-box-head {color: #26B6EF;float: left;font-size: 16px;font-weight: 600;padding: 0 0px 0 0;}.book-box .book-image .book-box-head { margin: 0px 0 0px;}.book-image a {width: 100%;}.book-box-head {text-decoration: none;color: #1e1e1e !important;margin: 0 0 5px 0;}.book-image img {float: left;height: 100%;-o-object-fit: cover;object-fit: cover;width: 100%;vertical-align: middle;border-style: none;}.book-box-info {width: calc(100% - 50px);float: left;padding-left: 20px;} .book-box .book-box-info .book-box-head { width: calc(100% - 130px);}.book-box h4 {text-transform: uppercase;background: #f6f6f6 none repeat scroll 0 0;float: right;font-size: 12px;font-weight: 600;margin: 5px 0 0;padding: 0px 10px;}.author {float: left;font-size: 14px;padding: 4px 0;margin: 0;width: 100%;}.star-rating {display: none;}.book-box .description {float: left;font-size: 13px;font-weight: 400;margin: 5px 0 10px;width: 100%;line-height: 20px;color: #666;}.book-box-bottom{display: block;}.avail-detail .material-icons {color: #8c8c8c;font-size: 21px !important;}.book-box-bottom-btn{display:none;}.avail-detail p{font-size: 15px;margin-bottom: 0;float: left;width: auto;min-width: 120px;margin-top: 0px;}.Placeholders {height:60px;  width: 100%;    display: flex;  box-shadow: 0px 0px 1px #F2F2F2;  color: #ffffff; overflow:hidden; padding: 0px 0;  text-align: center;  align-items: center;  justify-content: center;}.Placeholders.primary {background-color: #177BBB;}.Placeholders.info {background-color: #03A9F4;}.Placeholders.success {background-color: #8BC34A;}.Placeholders.mint {background-color: #26A69A;}.Placeholders.warning {background-color: #FFB300;}.Placeholders.danger {  background-color: #F44336;}.Placeholders.purple {background-color: #AB47BC;}.Placeholders.pink {background-color: #F06292;}.Placeholders.datk {background-color: #3A444E;}.Placeholders.gray { background-color: #E9EEEF;}.material-icons {font-size: 30px !important;color: #fff;}.description {display: none;}.modal-dialog{display: none;}</style>');
      mywindow.document.write('</head><body>');    
      mywindow.document.write('<h2 style="text-align: center;margin: 0;padding: 3px 0;float: left;width: 100%;}">Popular Titles</h2>');
      mywindow.document.write('<h4 style="text-align: center;margin-bottom: 40px;">'+libraryName+'</h4>');
      mywindow.document.write(content);
      mywindow.document.write('</body></html>');
      mywindow.document.close();
      mywindow.onload = function () {
        const images = mywindow.document.images;
        let loaded = 0;
        function triggerPrint() {
          mywindow.focus();
          mywindow.print();
        }
        if (images.length === 0) {
          setTimeout(triggerPrint, 300);
        } else {
          Array.from(images).forEach((img) => {
            if (img.complete) {
              loaded++;
              if (loaded === images.length) setTimeout(triggerPrint, 300);
            } else {
              img.onload = img.onerror = () => {
                loaded++;
                if (loaded === images.length) setTimeout(triggerPrint, 300);
              };
            }
          });
      }
    };
    mywindow.onafterprint = function () {
      mywindow.close();
    };
      return true;
    }

  printFn(content,libraryname = ''){
    var mywindow = window.open('', '_blank');
    mywindow.document.write('<html  moznomarginboxes mozdisallowselectionprint><head><title>Print</title><style>.hangingindent {padding-left: 36px ;text-indent: -36px; }</style>');
    mywindow.document.write('</head><body>');    
    mywindow.document.write('<h2 style="text-align:center">Popular Titles</h2>');
    mywindow.document.write('<h4 style="text-align:center;margin-bottom: 40px;">'+libraryname+'</h4>');
    mywindow.document.write(content);
    mywindow.document.write('</body></html>');
    mywindow.document.close();
    mywindow.focus();
    mywindow.print();
    mywindow.close();
    return true;
  }

  //Date picker options.
options: DatepickerOptions = {
    minYear: 1970,
    maxYear: 2030,
    format: 'MM-dd-yyyy',
    formatTitle: 'MMMM yyyy',
    formatDays: 'EEEEEE',
    firstCalendarDay: 0, // 0 - Sunday, 1 - Monday
    minDate: this.lastDayDate, // Minimal selectable date
    //barTitleIfEmpty: 'Desired Date',
    inputClass: 'holdDesireDate',
    placeholder: 'Select Date', // HTML input placeholder attribute (default: '')
    //addStyle: {}, // Optional, value to pass to [ngStyle] on the input field
    //fieldId: 'holdDesireDate', // ID to assign to the input field. Defaults to datepicker-<counter>
   // useEmptyBarTitle: false, // Defaults to true. If set to false then barTitleIfEmpty will be disregarded and a date will always be shown 
  }

   //Showing add form for hold.
  showAddFormHold(resourceId,event){
    //if(!this.cookieService.check('info')){
    if (!localStorage.getItem('info')){
      $('#loginSpanMessage').remove();
        document.getElementById("loginLia").click();
        $('#loginError').after('<span id="loginSpanMessage">Log in to place a hold on this resource.</span>');
        setTimeout(function(){
          $('#loginSpanMessage').remove();
        },10000);
        ///this.isPatronLogin=true;
    } 
  }

  //Hide adding form
  hideAddForm(){
    this.showAddFormStatus = false; 
    this.showHoldDate = false;     
  }

  //Showing hold date.
  showHoldDateFn(event){
    if( $(event.target).is(':checked')){
      this.showHoldDate = true;
    } else {
      this.showHoldDate = false;
      this.date = new Date(Date.now());
    }
  }

  //Holding request
  holdResource(event, resourceId,i){
    $(event.target).val('Wait...').attr('disabled', 'disabled');
    // var desiredDate = $('#datepicker-'+i).val();
    var desiredDate = null;
    if(this.showHoldDate){
      desiredDate = $('.holdDesireDate').val();
    }
    var auth = localStorage.getItem('token');
    var sessionId:any = 0;
    if(this.cookieService.check( 'renewSession') ){
      var sessionId:any = this.cookieService.get( 'renewSession');
    }
    this.homepageService.holdResource(sessionId,resourceId,desiredDate, auth).subscribe( (data:any) => {
        if(data.status){
            this.bulletinlist.data.resources[i].holdId = data.data.circHoldId;
            this.bulletinlist.data.resources[i].canHold = false;
            this.cookieService.set( 'renewSession', data.data.sessionId, 365,'/'); 
            this.notifier.notify( 'success', data.message);
          } else {
              this.notifier.notify( 'error', data.message);
          }
          $(event.target).val('Hold').removeAttr('disabled');
          $('#closeHoldAdd-'+resourceId).click();
          this.showHoldDate = false;
          this.date = new Date(Date.now());
    },(err) => {
      this.homepageService.holdResource(sessionId, resourceId, desiredDate, auth).subscribe((data: any) => { },
        (error) =>{
     
              $(event.target).val('Hold').removeAttr('disabled');
              this.notifier.notify('error', 'Something Went Wrong');
      });
      //$(event.target).val('Hold').removeAttr('disabled');
      //this.notifier.notify( 'error', 'Something Went Wrong');
    });
  }
  
  //Cancel hold request
  cancelHold(event, holdId,resourceId,i){ 
    var token = localStorage.getItem('token');
    this.bulletinlist.data.resources[i].holdId = null;
    $('#cancelholdsClose-'+resourceId).trigger('click');
    this.homepageService.cancelHoldAccount(holdId, token).subscribe((data:any) => {
      if(data.status){
        this.notifier.notify( 'success', data.message+' successfully');
        this.bulletinlist.data.resources[i].canHold = true;
      } else {
        this.bulletinlist.data.resources[i].holdId = holdId;
        this.bulletinlist.data.resources[i].canHold = false;
        this.notifier.notify( 'error', data.message);        
      }
    },(err) => {
      this.notifier.notify( 'error', 'Something Went Wrong');
    });
  }
  
}
